import { State } from '../../../interfaces/State';

export const selectStreakScreen = (state: State) => state.get('streakScreen');
